import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";
import usePath from "@/utils/hooks/client/usePath";

import type { RequestKlubCategoryNameInterface } from "./travelStoryInterface/getKlubCategoryInterface";
import { ResponseKlubCategoryListInterface } from "./travelStoryInterface/getKlubCategoryInterface";
import type { RequestTravelStoryRecommendInterface } from "./travelStoryInterface/getTravelStoryRecommendInterface";
import { ResponseTravelStoryRecommendInterface } from "./travelStoryInterface/getTravelStoryRecommendInterface";

class TravelStoryServiceApi {
  private baseUrl: string;

  private basePath: string;

  private basePathV2: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "travelStory";
    this.basePathV2 = `v2/${this.basePath}`;
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************
  // getTravelStoryRecommend /api/v2/travelStory/recommend (Homepage & Klub diving detail)
  // getKlubStoriesCategory /api/v2/travelStory/klubStory (Klub Stories Homepage)

  async getTravelStoryRecommend(
    params: RequestTravelStoryRecommendInterface,
  ): Promise<ResponseTravelStoryRecommendInterface[]> {
    try {
      const { dynamicImportJsonPath } = usePath();
      const responseJson: ResponseTravelStoryRecommendInterface[] =
        await dynamicImportJsonPath(`${this.basePathV2}/recommend`);

      if (responseJson && responseJson.length > 0) {
        return responseJson.map(
          (item: ResponseTravelStoryRecommendInterface) =>
            new ResponseTravelStoryRecommendInterface(item),
        );
      }

      // Fallback to API request if responseJson is invalid
      const queryParams = new URLSearchParams(params as any);
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePathV2}/recommend?${queryParams}`,
        "GET",
      )) as any;

      return response.map(
        (item: ResponseTravelStoryRecommendInterface) =>
          new ResponseTravelStoryRecommendInterface(item),
      );
    } catch (error) {
      // console.error("Error getting recommended travel stories:", error);
      return [];
    }
  }

  async getKlubStoriesCategory(
    params: RequestKlubCategoryNameInterface,
  ): Promise<ResponseKlubCategoryListInterface[]> {
    const queryParams = new URLSearchParams(params as any);

    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePathV2}/klubStory?${queryParams}`,
        "GET",
      )) as any;

      return response.map(
        (item: any) => new ResponseKlubCategoryListInterface(item),
      );
    } catch (error) {
      // console.error("Error fetching klub stories:", error);
      return [];
    }
  }
}
export default TravelStoryServiceApi;
